import { useTranslation } from "react-i18next";

import { joinTribe } from "@/services/api";
import { AlertTypes } from "@/utils/atoms";
import { TranslationKey } from "@/utils/translationKey";

import { useAlert } from "./useAlert";

// TODO: adapt the messages below once backend improved it's error message
const tribeErrorKey: Record<string, TranslationKey> = {
  '400 Bad Request: ""Could not join Tribe : Already a member""':
    "friendsWithBenefits.joinGroup.error.alreadyInGroup",
  '400 Bad Request: ""Could not join Tribe : Tribe has been dissolved""':
    "friendsWithBenefits.joinGroup.error.deletedGroup",
  '400 Bad Request: ""Could not join Tribe : Wholesale customer not allowed to join Tribe""':
    "translation:Common.friendsWithBenefits.businessCustomer",
  '400 Bad Request: ""Could not join Tribe : Tribe is full""':
    "friendsWithBenefits.joinGroup.error.tribeFull",
  '400 Bad Request: ""Could not create Tribe : payment type not allowed""':
    "friendsWithBenefits.joinGroup.error.paymentMethod",
};

// "Tribe not found" and any unknown error read as not found.
const getTribeErrorKey = (error: string): TranslationKey =>
  Object.prototype.hasOwnProperty.call(tribeErrorKey, error)
    ? tribeErrorKey[error]
    : "friendsWithBenefits.joinGroup.error.notFound";

export const useHandleJoinTribe = () => {
  const showAlert = useAlert();
  const { t } = useTranslation();

  const join = (tribeId: string, onSuccess?: () => void) =>
    joinTribe(tribeId)
      .then(() => {
        showAlert({
          text: t("friendsWithBenefits.joinGroup.sucess"),
          type: AlertTypes.success,
        });
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((e) => {
        showAlert({
          text: t(getTribeErrorKey(e?.response?.data)),
          type: AlertTypes.error,
        });
        throw e;
      });

  return join;
};
